/**
 * @fileoverview "Last Updated" label for a banking page's header filters row.
 * @description A small right-aligned label + date pair, matching the InsightBox Banking design
 * system's own `PageFilterBar.tsx` (its trailing `LAST_UPDATED` block) — split out as its own small
 * component since this app's convention is a `filters` slot on `PageHeader` built per-page from
 * smaller pieces, rather than one monolithic filter-bar component owning the whole heading row. The
 * date itself comes from the banking dataset's own `meta.lastUpdated`, not a static constant.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useTranslation } from 'react-i18next'

interface LastUpdatedLabelProps {
  value: string
}

/**
 * @component
 * @param {LastUpdatedLabelProps} props - The date string to display.
 * @param {string} props.value - The banking dataset's `meta.lastUpdated` value (e.g. "05 Aug
 * 2026").
 */
function LastUpdatedLabel({ value }: LastUpdatedLabelProps) {
  const { t } = useTranslation()

  return (
    <div className="text-right">
      <p className="text-xs text-slate">{t('banking.filters.lastUpdated')}</p>
      <p className="text-xs font-semibold text-ink">{value}</p>
    </div>
  )
}

export default LastUpdatedLabel
